<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <div class="wrapper">
        <app-header></app-header>
        <app-sidebar [page]="'settings'" [subPage]="'currencies'"></app-sidebar>

        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0">Settings</h1>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li class="breadcrumb-item"><a href="#">Settings</a></li>
                                <li class="breadcrumb-item active">Currencies</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'currencies'"></app-module-menu>
                    <div class="row">
                        <div class="modal fade" id="modal-currency-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('country') || checkService.canModify('country')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="card card-primary card-outline mb-0">
                                        <div class="card-header">
                                            <h4 class="card-title">{{formHeader}}</h4>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                                            </div>
                                        </div>
                                        <form [formGroup]="dataForm">
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label for="code">Currency Code</label>
                                                    <input type="text" required class="form-control text-uppercase" [ngClass]="(code.invalid && (code.dirty || code.touched)) ? 'is-invalid' : (code.valid)? 'is-valid':''" formControlName="code" id="code" placeholder="USD">
                                                    <div *ngIf="code.invalid && (code.dirty || code.touched)" class="invalid-feedback">
                                                        <div *ngIf="code.errors.required">Currency code is required</div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label for="name">Currency Name</label>
                                                    <input type="text" required class="form-control" [ngClass]="(name.invalid && (name.dirty || name.touched)) ? 'is-invalid' : (name.valid)? 'is-valid':''" formControlName="name" id="name" placeholder="United States Dollar">
                                                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="invalid-feedback">
                                                        <div *ngIf="name.errors.required">Currency name is required</div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label for="symbol">Currency Symbol</label>
                                                    <input type="text" required class="form-control" [ngClass]="(symbol.invalid && (symbol.dirty || symbol.touched)) ? 'is-invalid' : (symbol.valid)? 'is-valid':''" formControlName="symbol" id="symbol" placeholder="$">
                                                    <div *ngIf="symbol.invalid && (symbol.dirty || symbol.touched)" class="invalid-feedback">
                                                        <div *ngIf="symbol.errors.required">Currency symbol is required</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-footer">
                                                <input type="hidden" formControlName="ref" id="ref">
                                                <button type="submit" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                                <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-default">Cancel</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-coins"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right">
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('country')" data-toggle="modal" data-target="#modal-currency-form" (click)="onCancel()">
                                                    <i class="fas fa-plus"></i> Add Currency
                                                </button>&nbsp;
                                                <a [routerLink]="['/settings/currencies']" class="btn btn-primary btn-sm" type="button">All</a>&nbsp;
                                                <a [routerLink]="['/settings/currencies/active']" class="btn btn-primary btn-sm" type="button">Active</a>&nbsp;
                                                <a [routerLink]="['/settings/currencies/inactive']" class="btn btn-primary btn-sm" type="button">In-Active</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Code</th>
                                                    <th>Name</th>
                                                    <th>Symbol</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let currencyRow of currencyList;">
                                                    <td>{{currencyRow.code}}</td>
                                                    <td>{{currencyRow.name}}</td>
                                                    <td>{{currencyRow.symbol}}</td>
                                                    <td>
                                                        <span [class]="currencyRow.status?.active === true ? 'badge bg-success' : currencyRow.status?.inactive === true ? 'badge bg-warning' : 'badge bg-danger'" [innerHTML]="currencyRow.status?.active === true ? 'Active' : currencyRow.status?.inactive === true ? 'In-Active' : 'Deleted'"></span>
                                                    </td>
                                                    <td>{{currencyRow.created}}</td>
                                                    <td>{{currencyRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('country')" data-toggle="modal" data-target="#modal-currency-form" (click)="getEdit(currencyRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Activate" *ngIf="checkService.canModify('country')" [hidden]="currencyRow.status?.active === true" data-toggle="modal" data-target="#modal-activate-currency" (click)="getDataFromList(currencyRow.code, currencyRow.ref)">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Deactivate" *ngIf="checkService.canModify('country')" [hidden]="currencyRow.status?.inactive === true" data-toggle="modal" data-target="#modal-deactivate-currency" (click)="getDataFromList(currencyRow.code, currencyRow.ref)">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify('country')" data-toggle="modal" data-target="#modal-delete-currency" (click)="getDataFromList(currencyRow.code, currencyRow.ref)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="currencyList.length == 0">
                                                    <td colspan="7" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Code</th>
                                                    <th>Name</th>
                                                    <th>Symbol</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div class="card-footer" *ngIf="currencyList.length > 0">
                                        <app-pagination [url]='url' [counts]='count' (refresh)="getCurrencies($event)"></app-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <app-footer></app-footer>
    </div>
</div>

<div class="modal fade" id="modal-activate-currency">
    <div class="modal-dialog">
        <div class="modal-content bg-secondary">
            <div class="modal-header">
                <h4 class="modal-title">Activate Currency</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <p [innerHTML]="'This action will activate '+currencyName+'. Are you sure you want to continue ?'"></p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-light" data-dismiss="modal">Close</button>
                <button type="button" (click)="changeCurrencyStatus('activate', currencyRef)" class="btn btn-outline-light">Activate Currency</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-deactivate-currency">
    <div class="modal-dialog">
        <div class="modal-content bg-secondary">
            <div class="modal-header">
                <h4 class="modal-title">Deactivate Currency</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <p [innerHTML]="'This action will deactivate '+currencyName+'. Are you sure you want to continue ?'"></p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-light" data-dismiss="modal">Close</button>
                <button type="button" (click)="changeCurrencyStatus('deactivate', currencyRef)" class="btn btn-outline-light">Deactivate Currency</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-delete-currency">
    <div class="modal-dialog">
        <div class="modal-content bg-danger">
            <div class="modal-header">
                <h4 class="modal-title">Remove Currency</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <p [innerHTML]="'This action will remove '+currencyName+'. This action is not reversible, are you sure you want to continue ?'"></p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-light" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-outline-light" (click)="deleteCurrency(currencyRef)">Delete Currency</button>
            </div>
        </div>
    </div>
</div>
